import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ScrapCars from "./component";
import { updateLeadSource } from "../settings/actions";
import { fetchScrapCarContent } from "./actions";

const mapStateToProps = ({
    meta: {
        isSSR
    },
    scrapCars: {cmsData}
}) => ({
    isSSR,
    cmsData
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateLeadSourceConnect: updateLeadSource,
    fetchDataConnect: fetchScrapCarContent
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ScrapCars);
